import Model, { ID, Integer } from 'src/models/Model'

export default class PaymentType extends Model {
  static name = 'PaymentType'

  static isConfiguration = true

  static deletable = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Site]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        default: null
      },
      description: {
        type: String,
        default: null
      },
      color: {
        type: String,
        default: '#f2c037'
      },
      enabled: {
        type: Boolean,
        default: true
      },
      displayAsButton: {
        type: Boolean,
        default: false
      },
      hasDetailText: {
        type: Boolean,
        default: false
      },
      detailTextRequired: {
        type: Boolean,
        default: false
      },
      detailTextFieldName: {
        type: String,
        default: null
      },
      hasPrompt: {
        type: Boolean,
        default: false
      },
      promptMessage: {
        type: String,
        default: null
      },
      requiresAuthorization: {
        type: Boolean,
        default: false
      },
      displayOrder: {
        type: Integer,
        default: 100
      }
    }

    this.paginate = true
  }
}
